import { type ReactElement, useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Tabs } from '$components/tabs/tabs';
import type { TabsNavigationProps } from '$components/tabs/tabs.types';

export function TabsNavigationSidecar({ routes, onTabChange, shouldChangeTabOnActive }: TabsNavigationProps): ReactElement {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTabPath, setActiveTabPath] = useState('');

  const goTo = useCallback(
    (path: string): void => {
      const nextSearchParams = new URLSearchParams(searchParams);
      const currentRoute = nextSearchParams.get('sidecarRoute') || '';
      const updatedRoute = currentRoute.replace(/\/[^/]+$/, `/${path}`);
      const targetRoute = updatedRoute || currentRoute;

      nextSearchParams.set('sidecarRoute', decodeURIComponent(targetRoute));
      setSearchParams(nextSearchParams);
    },
    [searchParams, setSearchParams],
  );

  useEffect(() => {
    if (shouldChangeTabOnActive && activeTabPath) {
      goTo(activeTabPath);
    }
  }, [shouldChangeTabOnActive, activeTabPath, goTo]);

  const isActivePath = (path: string): boolean => searchParams.get('sidecarRoute')?.endsWith(path) ?? false;

  const handleTabClick = (path: string) => {
    if (onTabChange) {
      onTabChange();
      setActiveTabPath(path);
    } else {
      goTo(path);
      setActiveTabPath('');
    }
  };
  return <Tabs handleTabClick={handleTabClick} isActivePath={isActivePath} routes={routes} />;
}
